import React from 'react';
import ArrowLeft from '../assets/svg/arrow-left.svg';

export const backBtnLabel = (
  <>
    <ArrowLeft className="back-icon" key="back-icon" />
    <span className="back-text" key="back-text">Назад</span>
  </>
);
